import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/connect/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <main className="page-wrap px-4 pb-8">
      <div className="mb-8">
        <h1 className="display-title text-[2rem] mb-2">Connect Your Bank</h1>
        <p className="text-[--ink-soft] text-sm m-0">
          Choose your preferred connection provider to link your financial accounts.
        </p>
      </div>

      <div className="grid grid-cols-[repeat(auto-fit,minmax(320px,1fr))] gap-5 max-w-4xl">
        <Link to="/connect/plaid" className="no-underline">
          <article className="feature-card rounded-md p-6 h-full">
            <div className="text-[2rem] text-[--green] mb-3 opacity-70">🏦</div>
            <h3 className="text-lg mb-2">Plaid</h3>
            <p className="text-[--ink-soft] text-sm leading-normal m-0 mb-4">
              Industry-standard financial data aggregator. Connect to thousands of banks and
              financial institutions with secure, reliable access.
            </p>
            <div className="text-[--green] text-xs font-mono uppercase tracking-wide mt-auto">
              Connect with Plaid →
            </div>
          </article>
        </Link>

        <Link to="/connect/mx" className="no-underline">
          <article className="feature-card rounded-md p-6 h-full">
            <div className="text-[2rem] text-[--green] mb-3 opacity-70">✦</div>
            <h3 className="text-lg mb-2">MX</h3>
            <p className="text-[--ink-soft] text-sm leading-normal m-0 mb-4">
              Modern financial data platform with enhanced data quality and verification.
              Alternative provider for connecting your accounts.
            </p>
            <div className="text-[--green] text-xs font-mono uppercase tracking-wide mt-auto">
              Connect with MX →
            </div>
          </article>
        </Link>
      </div>
    </main>
  );
}
